import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/discover', label: 'Discover AGI' },
    { path: '/products', label: 'Products' },
    { path: '/websites', label: 'Deals' },
    { path: '/resources', label: 'Resources' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-carbon-950/95 backdrop-blur-md border-b border-white/5'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-8 h-8 bg-neon flex items-center justify-center">
              <i className="ri-links-line text-black text-lg"></i>
            </div>
            <span className="text-white font-bold text-lg tracking-tight">AFFILIX</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  isActive(link.path)
                    ? 'text-neon'
                    : 'text-white/60 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/dashboard"
              className="ml-4 px-5 py-2 text-white/50 hover:text-white text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              Sign In
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen((prev) => !prev)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          >
            <i
              className={`${
                mobileOpen ? 'ri-close-line' : 'ri-menu-line'
              } text-xl text-white`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-carbon-950 border-t border-white/5 px-6 py-4 space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMobileOpen(false)}
              className={`block text-sm font-medium py-3 cursor-pointer ${
                isActive(link.path) ? 'text-neon' : 'text-white/60'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/dashboard"
            onClick={() => setMobileOpen(false)}
            className="block text-sm font-medium py-3 text-white/50 cursor-pointer whitespace-nowrap mt-2"
          >
            Sign In
          </Link>
        </div>
      )}
    </nav>
  );
}
